import { useClient, withInitialized, useIsInitialized } from './use-client';
import { ExpertProfile, Message, Vendor } from '@outdoorly/chat-sdk';
import { useSubscription } from '../utilities';

export { useClient, useIsInitialized };

export const useCurrentExpert = (): withInitialized<{
  currentExpert: (ExpertProfile & { isAiExpert: boolean }) | undefined | null;
}> => ({
  initialized: useIsInitialized(),
  currentExpert: useSubscription(useClient().currentExpert, undefined)
});

export const useSendEvent = () => useClient().sendEvent;
export const useSendMessage = () => {
  return useClient().sendMessage;
};

export const useReadMessage = () => useClient().readMessage;
export const useMessage = (): withInitialized<{ messageList: Message[] }> => ({
  initialized: useIsInitialized(),
  messageList: useSubscription(useClient().messages, [])
});

export type SessionInfo = {
  isIdentified: boolean | undefined;
  hasOpenConversation: boolean | undefined;
  canStartNewChat: boolean | undefined;
  name: string | undefined;
  lead: string | null;
  vendorLiftTestId: string | null;
  isControlGroup: boolean | undefined;
};
export const useIsIdentified = (): withInitialized<{ identified: boolean | undefined }> => ({
  initialized: useIsInitialized(),
  identified: useSubscription(useClient().isIdentified, undefined)
});

export const useSessionInfo = (): withInitialized<{ sessionInfo: SessionInfo | undefined }> => {
  const client = useClient();
  return {
    initialized: useIsInitialized(),
    sessionInfo: {
      isIdentified: useSubscription(client.isIdentified, undefined),
      hasOpenConversation: useSubscription(client.hasOpenConversation, undefined),
      canStartNewChat: useSubscription(client.canStartNewChat, undefined),
      name: useSubscription(client.chatterName, undefined),
      lead: useSubscription(client.lead, null),
      vendorLiftTestId: useSubscription(client.vendorLiftTestId, null),
      isControlGroup: useSubscription(client.isControlGroup, undefined)
    }
  };
};

export const useShouldAppear = (): withInitialized<{ shouldAppear: boolean }> => ({
  initialized: useIsInitialized(),
  shouldAppear: useSubscription(useClient().shouldAppear, false)
});
export const useIsFindingExpert = (): boolean => {
  return useSubscription(useClient().isFindingExpert, false);
};

export const useIsTyping = () => useSubscription(useClient().isTyping, false);

export const useSendTyping = () => useClient().typing;
export const useVendor = (): withInitialized<{ vendor: Vendor | undefined }> => ({
  initialized: useIsInitialized(),
  vendor: useSubscription(useClient().vendor, undefined)
});
